import React, { Fragment, useMemo } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import noImage from "../../assets/images/no-image.jpg";
import {
  COLOR_STICKER_STATUS,
  LIST_OPTION_BAR_DETAIL_REVIEW_STATUS,
} from "helpers/constans";
import { truncate } from "utils";

interface TableContainerProps {
  item?: any;
  setLinkImage?: any;
  handleClickEdit?: any;
}

const TableGridSticker = ({
  item,
  setLinkImage,
  handleClickEdit
}: TableContainerProps) => {
  const { t } = useTranslation();

  const noImage1 = useMemo(() => {
    return noImage;
  }, []);


  return (
    <Fragment>
      <Col md={2} lg={2} key={item?.original?.id}>
        <Card className="border">
          <CardBody style={{ position: "relative" }}>
                <div className="w-100 text-center ">
                  <div
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflow: "hidden",
                      height: "200px",
                    }}
                    className="m-auto cursor-pointer position-relative"
                    onClick={() => {
                      setLinkImage(item?.original?.url);
                      document.body.className = "modal-open_img";
                    }}
                  >
                    <img
                      src={item?.original?.url}
                      className="flex-shrink-0 rounded w-100 h-100"
                      alt="thumbnail"
                      style={{
                        maxHeight: "200px",
                        objectFit: "contain",
                      }}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = noImage1;
                        currentTarget.style.objectFit = "cover"
                      }}
                    />

                    <div className="position-absolute top-0" style={{right: 0}}>
                      {item?.original?.status !== null && (
                        <span
                          className={`rounded-pill me-2 badge bg-${
                            COLOR_STICKER_STATUS[`${item?.original?.status}`] ||
                            "success"
                          }-subtle text-${
                            COLOR_STICKER_STATUS[`${item?.original?.status}`] ||
                            "success"
                          }`}
                        >
                          {t(
                            LIST_OPTION_BAR_DETAIL_REVIEW_STATUS?.find(
                              (s) => (s?.value) === (item?.original?.status)
                            )?.label || ""
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="d-flex align-items-center mt-3 "
                  style={{
                    justifyContent: "space-between",
                  }}
                >
                  <h5
                    className="cursor-pointer hover-underline mb-0 text-primary w-100"
                    onClick={() => handleClickEdit(item?.original)}
                  >
                    { truncate(item?.original?.name, 25) }
                  </h5>
                </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default React.memo(TableGridSticker);
